if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form
                    .querySelector("[name=id]")
                    ?.removeAttribute?.("disabled");
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );

                // gift card product - recipient form
                this.recipientForm = this.querySelector("recipient-form");
            }

            getSubmitButton() {
                var formId = this.form.getAttribute("id");

                return (
                    this.querySelector('[type="submit"]') ||
                    document.querySelector('[form="' + formId + '"]')
                );
            }

            getMessageWrapper() {
                this.messageWrapper =
                    this.messageWrapper ||
                    this.querySelector(".message-wrapper");

                if (this.messageWrapper) {
                    return this.messageWrapper;
                }

                this.messageWrapper = createFromTemplate("message-wrapper");
                this.getSubmitButton()?.after(this.messageWrapper);

                return this.messageWrapper;
            }

            onSubmitHandler(evt) {
                const cart = document.querySelector("cart-sidebar");

                if (!cart) {
                    return;
                }

                evt.preventDefault();
                const submitButton = this.getSubmitButton();
                if (submitButton.classList.contains("loading")) return;

                this.handleErrorMessage();

                if (!submitButton.querySelector(".loading-overlay"))
                    submitButton.prepend(
                        createFromTemplate("template-loading-overlay")
                    );

                submitButton.setAttribute("aria-disabled", true);
                submitButton.classList.add("loading");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                const formData = new FormData(this.form);
                cart.setActiveElement &&
                    cart.setActiveElement(document.activeElement);
                formData.append(
                    "sections",
                    cart.getSectionsToRender().map((section) => section.id)
                );

                formData.append("sections_url", window.location.pathname);
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);
                            return;
                        }

                        if (cart && response.sections) {
                            cart && cart.renderContents(response);
                        } else {
                            // sometime Shopify doesn't return requested sections
                            // in such case reload page
                            window.location.reload();
                        }
                        // cartSidebar && cartSidebar.triggerCartSidebarOnSubmit(response);

                        // hide gift card recipient form on submit
                        if (this.recipientForm)
                            this.hideRecipientForm(this.recipientForm);
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        submitButton.classList.remove("loading");
                        submitButton.removeAttribute("aria-disabled");
                    });
            }

            hideRecipientForm(recipientForm) {
                const input = recipientForm.querySelector("input");
                const fields = recipientForm.querySelector(".recipient-fields");

                if (input.checked) {
                    let animation = fields.animate(
                        { height: [fields.clientHeight + "px", "0"] },
                        { duration: 300, easing: "linear" }
                    );

                    input.checked = false;
                    animation.onfinish = () => {
                        fields.style.height = "0";
                    };
                }
            }

            handleErrorMessage(errorMessage = false) {
                const messageWrapper = this.getMessageWrapper();

                // gift-card recipient form error messages
                if (
                    errorMessage.email ||
                    errorMessage.send_on ||
                    errorMessage.message
                )
                    errorMessage =
                        errorMessage.email ||
                        errorMessage.send_on ||
                        errorMessage.message;

                this.errorMessage =
                    this.errorMessage ||
                    messageWrapper.querySelector(".error-message");
                this.errorMessage.textContent = errorMessage || "";
                if (errorMessage) messageWrapper.removeAttribute("hidden");
                else messageWrapper.setAttribute("hidden", true);
            }
        }
    );
}



document.addEventListener("DOMContentLoaded", function() {
    const targetNode = document.getElementById('product-option'); // The container where your options are loaded

    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const mutationCallback = function(mutationsList, observer) {
        // Get all radio buttons inside the case-sector class
        const radios = document.querySelectorAll('.case-sector input[type="radio"]');
        console.log("Radio Buttons Found:", radios);
        // Get all image slides in the slider
        const galleryComponent = document.querySelector('.product__info-block');
        const allSlides = galleryComponent.querySelectorAll('.slider__slide');
        // 動画スライドを除外し、画像スライドだけをマッピング対象にする
        // クラスで判定することで、2枚目以降の動画(template内で<video>が非レンダリング)も確実に除外
        const slides = Array.from(allSlides).filter(s => !s.classList.contains('slider__slide--video'));
        console.log("Image Slides Found (excluding video):", slides);

        // Ensure radios and slides exist
        if (radios.length > 0 && slides.length > 0) {
            // Loop through each radio button and attach event listener
            radios.forEach((radio, index) => {
                radio.addEventListener('change', function(event) {
                    // ユーザーの能動的なクリックのみに反応（デフォルト選択やプログラム的変更は無視）
                    if (!event.isTrusted) return;

                    if (this.checked) {
                        // Log the selected radio and index for debugging
                        console.log(`Radio ${index + 1} selected`);

                        // Get the corresponding slide for the selected radio button
                        const selectedSlide = slides[index];

                        console.log('Selected slide:', selectedSlide);
                        // Remove the 'slide-active' class from the current active slide
                        const currentActiveSlide = document.querySelector('.slider__slide.slide-active');
                        console.log('Current active slide:', currentActiveSlide);



                      
                        if (currentActiveSlide) {
                          
                            currentActiveSlide.classList.remove('slide-active');
                            console.log('Removed active class from current slide');
                        }

                        // Set the new selected slide as active
                        if (selectedSlide) {
                            selectedSlide.classList.add('slide-active');
                            console.log('Added active class to new slide');
                        } else {
                            console.log('No corresponding slide found for radio button');
                        }

                        // Try finding the slider with a broader selector
                        let slider = document.querySelector('.slider.slider--desktop');
                        if (!slider) {
                            console.log('Slider with .slider--desktop not found, trying .slider');
                            slider = document.querySelector('.slider'); // Try a more general selector
                        }

                        if (slider) {
                            console.log('Slider element found:', slider);
                            console.log('Selected slide offsetLeft:', selectedSlide?.offsetLeft);
                            slider.scrollTo({
                                top: 0,
                                left: selectedSlide ? selectedSlide.offsetLeft : 0,
                                behavior: 'smooth'
                            });
                            console.log('Slider scrolled to the selected slide');
                        } else {
                            console.log('Slider element still not found, check selector or if it exists in the DOM');
                        }
                      }
                });
            });

            // Stop observing once radios and slides are found
            observer.disconnect();
        } else {
            console.log('Radio buttons or slides not found yet');
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(mutationCallback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
});